import axios from "axios";
import { BASE_MODULO } from "./base";

export const ProfileService = {
  getCursosFormacion: (email = "") =>
    axios.get(
      `http://localhost:8080/Inducciones/index.php/RequestService/getCourseByEmail/${email}`),


  getCursosNodo: (email = "") =>
    axios.get(
      `${BASE_MODULO}RequestService/getHistoricalSume/${email}`
    ).then((response) => {
      if (response.status == 200) {
        return response.data.cursos
      }
      return []
    }
    )
};
